import React, { useState } from "react";
import { useMutation } from "react-relay";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import {ProjectCreateTreeButtonProps} from "./project-create-tree-button.types";
import {CREATE_BRANCH_ROOT_NODE_MUTATION} from "./project-create-tree-button.graphql";
import {getTreeEditorPath} from "../../../../app/routes/GraphEditorRoutes";
import {
    projectCreateTreeButton_CreateBranchRootNodeMutation
} from "../../../../__generated__/projectCreateTreeButton_CreateBranchRootNodeMutation.graphql";
import {
    CreateTreeFormState,
    TreeCreationMutation
} from "../../../../app/components/tree/tree/create-tree-form/create-tree-form.types";
import {CreateTreeForm} from "../../../../app/components/tree/tree/create-tree-form";

export const ProjectCreateTreeButton = ({ rootNodesConnectionId }: ProjectCreateTreeButtonProps) => {
    const navigate = useNavigate();
    const [displayMaximizable, setDisplayMaximizable] = useState(false);

    const [createBranchRootNode, isCreatingBranchRootNode] =
        useMutation<projectCreateTreeButton_CreateBranchRootNodeMutation>(
            CREATE_BRANCH_ROOT_NODE_MUTATION,
        );

    const option: TreeCreationMutation = {
        mutation: (formValues: CreateTreeFormState) =>
            createBranchRootNode({
                variables: {
                    input: {
                        title: formValues.title,
                        vnrNumber: formValues.vnrNumber,
                        vnrInternalNumber: formValues.vnrInternalNumber,
                        vnrPassword: formValues.vnrPassword,
                        validFrom: formValues.validFrom,
                        validTo: formValues.validTo,
                        pacPointsAmount: formValues.pacPointsAmount,
                        pharmaPointsAmount: formValues.bakPointsAmount,
                        certificateTemplateId: formValues.certificateTemplateId,
                        category: formValues.category,
                        certifierRef: formValues.certifierRef,
                        tags: formValues.tags,
                        length: formValues.length,
                    },
                    connections: [rootNodesConnectionId],
                },
                onCompleted: (response) =>
                    navigate(
                        getTreeEditorPath(
                            response.Admin.Tree.paediaPredefinedTemplateCreateBranchRootNode
                                ?.createdRootNode.node.id || "",
                        ),
                    ),
            }),
    };
    return (
        <>
            <Button
                label={"Neues Modul"}
                className={"mr-2"}
                disabled={isCreatingBranchRootNode}
                onClick={() => setDisplayMaximizable(true)}
            />

            <CreateTreeForm
                type={"create"}
                displayMaximizable={displayMaximizable}
                setDisplayMaximizable={setDisplayMaximizable}
                onSubmitCallback={(formValues: CreateTreeFormState) => {
                    option.mutation(formValues);
                }}
                isSubmittingMutation={isCreatingBranchRootNode}
            />
        </>
    );
};
